import type { EventLocationDetails } from "./types";

export function isCoordinateLocationValue(value?: string) {
  if (!value) {
    return false;
  }

  return Boolean(value.trim().match(/^-?\d+(?:\.\d+)?,\s*-?\d+(?:\.\d+)?$/));
}

export function resolveEventLocationValue(
  value: string,
  details?: EventLocationDetails
) {
  return details?.address || details?.label || value;
}
